import Vue from 'vue'
import App from './App.vue'
import {router} from './router/router'
import ElementUI from 'element-ui'
import { store } from './store/store';
import plTable from 'pl-table';
import AFTableColumn from 'af-table-column';
import 'element-ui/lib/theme-chalk/index.css'
// import './assets/css/element-variables.scss'   //多主题样式引进
import 'element-ui/lib/theme-chalk/reset.css'
import './assets/css/style.css'
import './common/dialog'
import * as filters from './utils/filters';

import preventReClick from '@/utils/preventReClick' //防多次点击，重复提交

import $ from 'jquery';
window.$ = require('jquery')
window.JQuery = require('jquery')
require('./page/meeting/plugin/jquery.PrintArea.js');
require('./page/meeting/plugin/printThis.js');
require('./page/meeting/plugin/jquery.print.js');


// const build = '2021-12-3 8：00'
// console.log(`时间:${build}`);

// const branch = 'master';
// console.log(`分支:${branch}`);

// const version = '2.0.26';
// console.log('版本:', version);

// const author = 'helloca';
// console.log('发布者:', author);

// const msg = [
//   '合并发版'
// ];
// console.groupCollapsed('本次修改:' + msg.length);
// msg.forEach((m, index) => {
//   console.log(index, m);
// })
// console.groupEnd();


Object.keys(filters).forEach(k => {
  Vue.filter(k, filters[k])
});

Vue.use(ElementUI)
Vue.use(plTable);
Vue.use(AFTableColumn)
let bus = new Vue();
Vue.prototype.bus = bus;
Vue.prototype.store = store;
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')

Vue.prototype.$getRoleBtns = function (menuCode, buttonAuthorize) {
  //情况按钮权限
  let menuBnt=menuCode.permissionList;
  if(null!=menuBnt)
  {
    for (let i = 0; i < menuBnt.length; i++) {
      const ele = menuBnt[i];
      for (const key in buttonAuthorize) {
        if (Object.prototype.hasOwnProperty.call(buttonAuthorize,key)) {
          const element = buttonAuthorize[key];
          if (element.key == ele.permissionDictKey) {
            element.btnEnable = true;
          }
         
        }
      }
    }
  }
}

Vue.prototype.openLoading = function() {
  const loading = this.$loading({           // 声明一个loading对象
    lock: true,                             // 是否锁屏
    text: '加载中',                         // 加载动画的文字
    spinner: 'el-icon-loading',             // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.6)',       // 背景颜色
    target: '.el-main, .table-flex',       // **需要遮罩的区域，这里写要添加loading的选择器**
    fullscreen: true,
    customClass: 'loadingclass'             // **遮罩层新增类名，如果需要修改loading的样式**
  })
  setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close();                        // 关闭遮罩层
  },5000)
  return loading;
}

// let ws;
// function initMessageCener() {
//   if ('WebSocket' in window){
//     ws = new WebSocket("ws://47.101.210.183:8888/ws/"+username);
//   }    
//   else if ('MozWebSocket' in window){
//   ws = new MozWebSocket("ws://47.101.210.183:8888/ws/"+username);
//   }
//   else{
//   alert("该浏览器不支持websocket");    
//   }
// } 